export const REPORTS_MASTER_PASSWORD = 'lighthousearabia';
